/*
* @auth 郭超
* @desc 录入数据多语言弹框
* @date 2022-6-10
* */

import Vue from 'vue'
import mtcLangInput from '@comp/mtcModule/mtcLangInput'

// 获取组件的原型
const mtcLangModalCons = Vue.extend(mtcLangInput)

export const langInputModal = ( data, callback, cancelCallback ) => {
  // 挂在组件
  const com = new mtcLangModalCons().$mount()
  // 添加dom进去
  document.body.appendChild(com.$el)
  // 调用组件内的方法打开模态框
  com.openLangDialog(data)
  // 改写组件内确认方法接收回调函数
  com.submit = () => {
    com.handleLangOk(callback)
  }
  // 改写组件内关闭方法接收回调函数
  com.cancel = () => {
    com.handleLangCancel(cancelCallback)
  }
}